<div class="container-fluid mt-3 department-detail-page">
  <!-- Page header with Edit button -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="dept-title mb-0">Department Details</h3>

    <!-- Edit Button on the top-right -->
    <button class="btn btn-edit" *ngIf="department" (click)="editDepartment(department.department_id)">
      <i class="fas fa-edit me-1"></i> Edit
    </button>
  </div>

  <!-- Main card -->
  <div class="dept-card">
    <div class="card-body p-0">
      <!-- Loading state -->
      <div *ngIf="isLoading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2 text-muted small">Loading department details...</div>
      </div>

      <!-- Error message -->
      <div *ngIf="!isLoading && loadError" class="alert alert-danger m-3">
        {{ loadError }}
      </div>

      <!-- Department details -->
      <div *ngIf="!isLoading && !loadError && department">
        <div class="department-details">
          <!-- Department name -->
          <div class="detail-row">
            <div class="detail-label"><strong>Department Name:</strong></div>
            <div class="detail-value">
              {{ department.department_name || '-' }}
            </div>
          </div>

          <!-- Foreman -->
          <div class="detail-row">
            <div class="detail-label"><strong>Foreman Name:</strong></div>
            <div class="detail-value">
              {{ department.department_Foreman_name || '-' }}
            </div>
          </div>

          <!-- Warehouse -->
          <div class="detail-row">
            <div class="detail-label"><strong>Warehouse Name:</strong></div>
            <div class="detail-value">
              {{ department.warehouse_name || '-' }}
            </div>
          </div>
          <div class="detail-row" *ngIf="department.rft_brands?.length">
            <div class="detail-label"><strong>Brands:</strong></div>
            <div class="detail-value">
              <ul>
                <li *ngFor="let brand of department.rft_brands">
                  {{ brand.brand_name }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Is Factory -->
          <div class="detail-row">
            <div class="detail-label"><strong>Is Factory:</strong></div>
            <div class="detail-value">
              {{ department.is_factory ? 'Yes' : 'No' }}
            </div>
          </div>

          <!-- Is Factory Counter Sale -->
          <div class="detail-row">
            <div class="detail-label"><strong>Is Technician Available:</strong></div>
            <div class="detail-value">
              {{ department.is_technician_available ? 'Yes' : 'No' }}
            </div>
          </div>

          <!-- Is New Product Request Supported -->
          <div class="detail-row">
            <div class="detail-label"><strong>Is New Product Request Supported:</strong></div>
            <div class="detail-value">
              {{ department.has_new_product_request ? 'Yes' : 'No' }}
            </div>
          </div>

          <!-- New Product ID Creator -->
          <div class="detail-row">
            <div class="detail-label"><strong>New Product ID Creator:</strong></div>
            <div class="detail-value">
              {{ department.assigned_employee_name || '-' }}
            </div>
          </div>

          <!-- Location (icon + lat/long text, opens popup map) -->
          <div class="detail-row">
            <div class="detail-label"><strong>Location:</strong></div>
            <div class="detail-value">
              <i class="fas fa-map-marker-alt location-icon" (click)="openLocationPopup()"></i>

              <span *ngIf="
                  department.department_latitude &&
                  department.department_longitude
                ">
                {{ department.department_latitude }},
                {{ department.department_longitude }}
              </span>

              <span *ngIf="
                  !department.department_latitude ||
                  !department.department_longitude
                ">
                Not Available
              </span>
            </div>
          </div>

          <!-- Work In Time -->
          <div class="detail-row">
            <div class="detail-label"><strong>Work In Time:</strong></div>
            <div class="detail-value">
              {{ formatTime24(department.work_in_time) }}
            </div>
          </div>

          <!-- Lunch Out Time -->
          <div class="detail-row">
            <div class="detail-label"><strong>Lunch Out Time:</strong></div>
            <div class="detail-value">
              {{ formatTime24(department.lunch_out_time) }}
            </div>
          </div>

          <!-- Lunch In Time -->
          <div class="detail-row">
            <div class="detail-label"><strong>Lunch In Time:</strong></div>
            <div class="detail-value">
              {{ formatTime24(department.lunch_in_time) }}
            </div>
          </div>

          <!-- Work Out Time -->
          <!-- Work Out Time -->
          <div class="detail-row">
            <div class="detail-label"><strong>Work Out Time:</strong></div>
            <div class="detail-value">
              {{ formatTime24(department.work_out_time) }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label"><strong>Store Responsible:</strong></div>
            <div class="detail-value">
              {{ department.store_incharge_employee_name || '-' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label"><strong>Safety Responsible:</strong></div>
            <div class="detail-value">
              {{ department.safety_responsible_employee_name || '-' }}
            </div>
          </div>
          <div class="detail-row" *ngIf="department.technicians?.length">
            <div class="detail-label"><strong>Technicians:</strong></div>
            <div class="detail-value">
              <ul>
                <li *ngFor="let tech of department.technicians">
                  {{ tech.technician_name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="detail-row" *ngIf="department.driver_delivery_employees?.length">
            <div class="detail-label"><strong>Delivery Men:</strong></div>
            <div class="detail-value">
              <ul>
                <li *ngFor="let d of department.driver_delivery_employees">
                  {{ d.employee_name }}
                </li>
              </ul>
            </div>
          </div>
          <!-- Weekly Time Schedule -->
          <div class="detail-row weekly-schedule-row" *ngIf="filteredWeeklySchedule?.length">
            <div class="detail-label"><strong>Weekly Time Schedule:</strong></div>
            <div class="detail-value">
              <div class="weekly-schedule-scroll">
                <table class="weekly-schedule-table">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Work In</th>
                      <th>Work Out</th>
                      <th>Lunch In</th>
                      <th>Lunch Out</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sched of filteredWeeklySchedule">
                      <td>{{ formatDayNumber(sched.day) }}</td>
                      <td>{{ sched.workin_time || '-' }}</td>
                      <td>{{ sched.workout_time || '-' }}</td>
                      <td>{{ sched.lunch_in_time || '-' }}</td>
                      <td>{{ sched.lunch_out_time || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Public Holidays -->
          <div class="detail-row" *ngIf="department.public_holidays?.length">
            <div class="detail-label"><strong>Public Holidays:</strong></div>
            <div class="detail-value">
              <ul>
                <li *ngFor="let holiday of department.public_holidays">
                  {{ holiday }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Members -->
          <div class="detail-row" *ngIf="department.members?.length">
            <div class="detail-label"><strong>Members:</strong></div>
            <div class="detail-value">
              <ul>
                <li *ngFor="let member of department.members">
                  {{ member.employee_name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- No department data -->
      <div *ngIf="!isLoading && !loadError && !department" class="alert alert-info m-3">
        No department details available.
      </div>
    </div>
  </div>
</div>

<!-- ================= Location Map Popup (NO jQuery) ================= -->
<div class="location-popup-backdrop" *ngIf="showLocationPopup">
  <div class="location-popup-card">
    <!-- Header -->
    <div class="location-popup-header d-flex justify-content-between">
      <span>Department location</span>
      <button type="button" class="close-btn" (click)="closeLocationPopup()">
        &times;
      </button>
    </div>

    <!-- Map -->
    <div class="location-popup-body">
      <google-map height="260px" width="100%" [center]="center" [zoom]="zoom">
        <map-marker *ngFor="let marker of markers" [position]="marker.position" [label]="marker.label"
          [title]="marker.title" [options]="marker.options">
        </map-marker>
      </google-map>
    </div>

    <!-- Lat / Long info -->
    <div class="location-popup-footer">
      <div>
        <strong>Latitude:</strong> {{ map_lat || 'Not Available' }}
      </div>
      <div>
        <strong>Longitude:</strong> {{ map_log || 'Not Available' }}
      </div>
    </div>
  </div>
</div>